import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getItems } from '../../services/items';

/** Every live item for the business, joined onto catalog variants for actions. */
function useItems(enabled = true) {
  const { user } = useUser();
  const businessId = user?.business?.id;

  return useQuery({
    queryKey: ['retail-items', businessId],
    queryFn: () => getItems({ businessId: businessId!, includeDeleted: false }),
    enabled: enabled && !!businessId,
  });
}

export default useItems;
